﻿export class trip_passenger {
    public index: number = 0;
    public price: number | null = null;
}